import WorldSystem from '../WorldSystem';
import ITask from '../../../Utility/Task/ITask';
import {
    GetAnimationClip,
    PlayAnimation,
    StartAnimation,
} from '../../Animation/AnimationHelper';
import Point from '../../../Utility/Point';
import Container from '../../../Prototype/Container';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { UIActions } from '../../../State/UI/UIActions';
import SurpriseCard from '../../../Prototype/World/SurpriseCard';
import Game from '../../../Game';
import Text from '../../../Prototype/Text';
import AnimationComponent from '../../../Component/Animation';
import Sprite from '../../../Prototype/Sprite';
import GameObject from '../../../GameObject/GameObject';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';

export default class UnlockBackCardTask implements ITask<WorldSystem> {
    private backcardTexture: string;

    constructor(backcardId: number) {
        this.backcardTexture = `backcard_${backcardId}`;
    }

    public *execute(system: WorldSystem): IterableIterator<number> {
        const state = system.state.getState();
        if (state.UIState.popupID) {
            system.state.dispatch(UIActions.hidePopup(state.UIState.popupID));
        }

        yield* this.loadBackCardtexture();

        const overlay = system.animator.getChildByName('overlay');
        StartAnimation(overlay, 'OverlayFadeIn');

        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);

        const container = GameObject.Instantiate(Container, {
            relativePosition: new Point(0.5, 0.5),
            anchor: new Point(0.5, 0.5),
        });

        const textEventCompleted = GameObject.Instantiate(Text, {
            text: Game.locale.getText('EventCompleted'),
            position: new Point(0, -240),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('unlockBackCard.eventCompleted'),
            alpha: 0,
        });
        textEventCompleted.addComponent(AnimationComponent);

        const textMysteryCard = GameObject.Instantiate(Text, {
            text: Game.locale.getText('MysteryCard'),
            position: new Point(0, -180),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('unlockBackCard.mysteryCard'),
            alpha: 0,
        });
        textMysteryCard.addComponent(AnimationComponent);

        const raysWhite = GameObject.Instantiate(Sprite, {
            texture: 'RaysWhite',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0, 0),
            alpha: 0.8,
        });
        raysWhite.addComponent(AnimationComponent);

        system.animator.addChild(container);
        container.addChild(raysWhite);
        container.addChild(textMysteryCard);
        container.addChild(textEventCompleted);

        // Add 3 (fake) surprise cards.
        let selected = -1;
        const cards = [];
        for (let i = 0; i < 3; i++) {
            const card = GameObject.Instantiate(SurpriseCard, {
                position: new Point(-220 + 220 * i, 0),
                scale: new Point(0, 0),
                texture: this.backcardTexture,
            });

            container.addChild(card);
            cards.push(card);

            card.on(GameObjectEvent.SELECTED, () => {
                selected = i;
            });
        }

        // Fade in texts.
        const fadeIn = { startAlpha: 0, endAlpha: 1, duration: 500 };
        StartAnimation(textEventCompleted, 'AlphaText', fadeIn);
        StartAnimation(textMysteryCard, 'AlphaText', fadeIn);

        // Wait until player select one card.
        while (selected === -1) yield;

        for (let i = 0; i < 3; i++) {
            cards[i].off(GameObjectEvent.SELECTED);

            if (i !== selected) {
                StartAnimation(cards[i], 'Alpha', {
                    startAlpha: 1,
                    endAlpha: 0,
                    duration: 300,
                });
            }
        }

        // Fade out texts.
        const fadeOut = { startAlpha: 1, endAlpha: 0, duration: 250 };
        StartAnimation(textEventCompleted, 'AlphaText', fadeOut);
        StartAnimation(textMysteryCard, 'AlphaText', fadeOut);

        // Rotate ray.
        StartAnimation(raysWhite, 'RayRotate', { rotationSpeed: 0.005 });

        // Move card to center and transform into backcard.
        yield* PlayAnimation(
            GetAnimationClip('SurpriseCardChoose', system.animator, {
                card: cards[selected],
                ray: raysWhite,
                scene: system.scene,
                container: container,
            })
        );

        // Fade out overlay.
        StartAnimation(overlay, 'OverlayFadeOut');

        system.animator.removeChild(container);
        container.destroy();
    }

    private *loadBackCardtexture(): IterableIterator<number> {
        let textureLoaded = false;

        Game.resource.add(
            this.backcardTexture,
            `resource/graphics/card_backs/${this.backcardTexture}.png`
        );
        Game.resource
            .wait(this.backcardTexture)
            .then(() => (textureLoaded = true));

        while (!textureLoaded) yield;
    }
}
